<template lang="pug">
.rece-info
  .f18.grey3.font-weight-bold.text-ct {{ title || "商品已下单，请完善你的收货信息" }}
  km-form.rece-info-form(
    :models='$data',
    :rules='rules',
    ref='form',
    labelWidth='74px',
    align_type='left',
    :hide-required-asterisk='true',
    :tipDirection='tipDirection'
  )
    km-form-item(label='收货人', ref='classCode')
      km-input.km-input-warp(v-model.trim='consignee', placeholder='请输入收货人名字')
    km-form-item(label='手机号码', prop='phone', ref='classCode')
      km-input.km-input-warp(v-model.trim='phone', placeholder='请输入收货人手机号码')
    km-form-item(label='选择地区')
      .idress
        km-form-item( label-width=0)
          km-select.select_warp_(v-model='provinceId', placeholder='请选择省')
            km-select-option(
              v-for='(province, index) in provinceList',
              :key='index',
              :value='province.id',
              :label='province.name'
            )
        km-form-item( label-width=0)
          km-select.select_warp_(v-model='cityId', placeholder='请选择市')
            km-select-option(
              v-for='(city, index) in cityList',
              :key='index',
              :value='city.id',
              :label='city.name'
            )
        km-form-item( label-width=0)
          km-select.select_warp_(v-model='countryId', placeholder='请选择区')
            km-select-option(
              v-for='(country, index) in countryList',
              :key='index',
              :value='country.id',
              :label='country.name'
            )
    km-form-item(label='详细地址', ref='classCode')
      km-input.km-input-warp(v-model.trim='address', placeholder='请输入详细地址')
  .submit-button(v-if="phone && consignee && address && cityId && countryId && provinceId" @click='save') 确认提交
  .submit-button.disabled(v-else) 确认提交
</template>
<script>
import { province, orderAddress } from '@/api'
export default {
  props: ['orderNo', 'tipDirection', 'title'],
  data() {
    return {
      rules: {
        phone: [
          {
            validator(rule, value, cb) {
              if (value) {
                if (value.length !== 11 || +value[0] !== 1) {
                  cb('请填写正确的手机号')
                } else {
                  cb()
                }
              }
            },
            trigger: 'blur',
          },
        ]
      },
      address: '',
      consignee: '',
      provinceId: '',
      cityId: '',
      countryId: '',
      phone: '',
      showError: true,
      provinceList: [],
      cityList: [],
      countryList: [],
    }
  },
  methods: {
    getProvinceList() {
      return new Promise((resolve, reject) => {
        province().then((res) => {
          if (res.status === 1) {
            this.provinceList = res.data
            resolve()
          }
        })
      })
    },
    save() {
      this.saveHandle().catch((e) => {})
    },
    async saveHandle() {
      await this.$refs['form'].validate()
      const res = await orderAddress({
        orderNo: this.orderNo,
        consignee: this.consignee,
        phone: this.phone,
        address: this.address,
        provinceId: this.provinceId,
        cityId: this.cityId,
        countryId: this.countryId,
      })
      if (res.status === 1) {
        this.$emit('success')
      } else {
        this.$alert(res.info)
      }
    },
  },
  watch: {
    provinceId(v) {
      console.log(v)
      this.cityList = []
      this.showError = false
      this.cityList = this.provinceList.filter((i) => i.id === v)[0].city
      this.countryList = []
    },
    cityId(v) {
      const data = this.cityList.filter((i) => i.id === v)
      this.showError = false
      this.countryList = data[0] ? data[0].country : []
    },
    countryId(v) {
      this.showError = false
    },
  },
  async mounted() {
    await this.getProvinceList()
  },
}
</script>

<style lang="less" scoped>
.idress {
  display: flex;
}
.select_warp_ {
  width: 83px !important;
  height: 32px !important;
  margin-right: 4px;
  cursor: pointer;
}
.km-input-warp {
  width: 256px !important;
  height: 32px !important;
  border-radius: 4px !important;
}
.km-input-warp.active,
.km-input-warp:focus {
  border-color: #fe8828;
}
.submit-button {
  width: 150px;
  height: 40px;
  background: #fe8828;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  margin: 19px auto 22px;
}
.submit-button.disabled{
  background: #ccc!important;
}
</style>
<style lang="less">
.rece-info {
  .rece-info-form {
    margin-top: 21px;
    .form-item {
      margin-bottom: 16px;
      div.form-item {
        margin-bottom: 0;
      }
    }
  }
  .select_warp_ .input_warp {
    border-radius: 4px !important;
  }
  .options_warp {
    width: 150px !important;
    .select_options {
      height: 32px;
      .contentLabel {
        line-height: 32px;
      }
    }
    .select_options.checked {
      .contentLabel {
        color: white;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Stu/receivingInformation/information.vue